import { NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BroverComponent } from './brover.component';

import { AuthClientModule} from './modules/auth-client/auth-client.module';
import { BroverMaterialModule} from './modules/brover-material/brover.material.module';
import { BroverRouterModule} from './modules/brover-router/brover.router.module';
import { LocationStrategy, PathLocationStrategy} from '@angular/common';
import { BroverInterceptorModule} from './modules/brover-interceptor/brover.interceptor.module';
import { BroverNotifyModule} from './modules/brover-notify/brover-notify.module';
import { BroverDefaultComponentModule} from './modules/brover-default-component/brover-default-component.module';

import { LocalStorageModule } from 'src/app/modules/local-storage/local-storage.module';
import { ComponentModule} from './modules/component/component.module';

@NgModule({
  declarations: [
    BroverComponent,
  ],
  imports: [
    BrowserModule,

    // Custom Modules
    AuthClientModule,
    BroverDefaultComponentModule,
    BroverRouterModule,
    BroverMaterialModule,
    BroverInterceptorModule,
    BroverNotifyModule,

    // Component Module
    ComponentModule,
    LocalStorageModule.forRoot({
      prefix: 'brover',
      storageType: 'localStorage'
    }),
  ],
  providers: [{ provide: LocationStrategy, useClass: PathLocationStrategy }],
  bootstrap: [BroverComponent]
})
export class BroverModule { }
